import { createFileRoute, redirect } from '@tanstack/react-router';

import { TrialBookingsSettings } from '~features/settings/trial-bookings/index';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { UserRoles } from '~entities/users';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/_settings/trial-bookings')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: TrialBookingsSettings,
});
